module.exports = __webpack_public_path__ + "static/media/hannah.bc96a8bd.jpg";